import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./serviceList.css";
import { Link } from "react-router-dom";
import { Parallax } from "react-scroll-parallax";

// Hook para detectar si es móvil
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const ServiceList = ({ services }) => {
  const isMobile = useIsMobile();

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    pauseOnFocus: true,
  };

  return (
    <div className="services-list-container" style={{ overflow: "hidden" }}>
      {services.map((service, index) => {
        const parallaxProps = isMobile
          ? { translateX: ["0px", "0px"] } // Sin efecto en móviles
          : {
            translateX:
              index % 2 === 0 ? ["0px", "50px"] : ["50px", "0px"],
          };

        return (
          <div className="container">
            <Parallax key={service.id || index} {...parallaxProps}>

              <div
                className={`row service-item ${index % 2 === 0 ? "normal-layout" : "reverse-layout"
                  }`}
              >
                <div className="col-md-6">
                  <div className="service-text">
                    <h4 style={{ color: service.bgColor }}>{service.title}</h4>
                    <h2
                      dangerouslySetInnerHTML={{ __html: service.subtitle }}
                    />
                    <p className="service-description">
                      {service.description}
                    </p>
                    <ul
                      className="features-list row"
                      style={{ "--before-color": service.bgColor }}
                    >
                      {service.features.map((feature, fi) => (
                        <div key={fi} className="col-md-6 feature-item">
                          <div
                            className="icon"
                            style={{ fill: service.bgColor }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                            >
                              <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4 9.4 24.6 9.4 33.9 0s9.4 24.6 0 33.9z" />
                            </svg>
                          </div>
                          <li>{feature}</li>
                        </div>
                      ))}
                    </ul>
                    <Link to="/contacto" className="service-button btn-general">
                      {/* {service.buttonText} */}
                      CONTÁCTANOS
                    </Link>
                  </div>
                </div>
                <div className="col-md-6">
                  <Slider
                    {...sliderSettings}
                    className="service-slider"
                    style={{ "--dot-color": service.bgColor }}
                  >
                    {service.images.map((img, idx) => (
                      <div key={idx}>
                        <div
                          className="service-image"
                          style={{ backgroundImage: `url(${img})` }}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>

            </Parallax>
          </div>
        );
      })}
    </div>
  );
};

export default ServiceList;
